<template>
  <fieldset>
    <legend>
      <span class="pull-left">{{ $t('form.other_absence.legend') }}</span>
      <!-- <a class="fa fa-question-circle" @click="displayModal($event, 0)" /> -->
      <a
        class="pull-right"
        ref="collapseLink"
        data-toggle="collapse"
        href="#collapse_other_absence"
        role="button"
        aria-expanded="true"
        aria-controls="collapse_other_absence"
      >
        <span class="fa fa-angle-up"></span>
        <span class="fa fa-angle-down"></span>
      </a>
    </legend>

    <modal v-show="modals[0]" @close="$set(modals, 0, false)">
      <h2 slot="modal-header">{{ $t('form.other_absence.legend') }}</h2>
      <div slot="modal-body"></div>
    </modal>

    <div class="collapse show" id="collapse_other_absence" ref="collapseElement">
      <div>
        <label for="other_absence_extended_rights">
          <input type="checkbox" id="other_absence_extended_rights" v-model="otherAbsence.extendedRights" />
          {{ $t('form.other_absence.extended_rights.label') }}
        </label>
      </div>

      <div v-show="otherAbsence.extendedRights">
        <div class="form-group">
          <label for="other_absence_description">{{ $t('form.other_absence.extended_rights.description.label') }}</label>
          <div class="input-group">
            <textarea
              rows="5"
              class="form-control"
              id="other_absence_description"
              :placeholder="$t('form.other_absence.extended_rights.description.placeholder')"
              v-model="otherAbsence.extendedRightsDescription"
              @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
              required
            />
            <div class="invalid-feedback">
              <invalid-cross></invalid-cross>
              <span>{{ $t('form.validation_error_message') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
export default {
  data() {
    return {
      otherAbsence: {
        extendedRights: false,
        extendedRightsDescription: ""
      }
    };
  },
  watch: {
    otherAbsence: {
      handler() {
        this.$store.commit("updateOtherAbsence", this.otherAbsence);
      },
      deep: true
    }
  }
};
</script>